/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=ed19a988&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=ed19a988&lang=scss&scoped=true"

import exportComponent from "F:\\System\\sengi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed19a988"]])

export default __exports__